import styled from "styled-components";
import {
  COLORS,
  responsive,
} from "../../../../../../../../styles/constants.style";
export const CareerGoalsWrapper = styled.div`
  .label-style {
    line-height: 22px;
    margin-top: 10px;
    color: ${COLORS.cirrus_black};

    ${responsive.MOBILE`
      margin-top: 0px;
    `}
  }
  .value-style {
    line-height: 20px;
    color: ${COLORS.cirrus_black};
  }
  .authorized-connections {
    display: flex;
    align-items: center;
  }

  .content {
    padding: 0px 16px 0 16px;
    width: 100%;
    ${responsive.MOBILE`
      padding: 0px 16px 0 8px;
    `}
  }

  .authorized-connections-section {
    padding-bottom: 24px;
    ${responsive.MOBILE`
      padding-bottom: 16px;
    `}
  }
  .preferences-section {
    padding-bottom: 24px;
    ${responsive.MOBILE`
      padding-bottom: 0;
    `}
  }
`;
